import { Injectable } from '@angular/core';

import { SUPPORTED_COUNTRIES } from '@store';

import { SupportedCountry } from '../models/supportedCountry.model';

@Injectable({
  providedIn: 'root',
})
export class SupportedCountriesService {
  constructor() {}

  getAllSupportedCountries(): SupportedCountry[] {
    return SUPPORTED_COUNTRIES;
  }

  getUniqueSupportedCountries(): SupportedCountry[] {
    return this.getAllSupportedCountries().filter((country) => !country.countryCode.includes('_'));
  }

  getUniqueSupportedCountriesSortedAlphabetically(): SupportedCountry[] {
    return this.getUniqueSupportedCountries().sort((a, b) => (a.country > b.country ? 1 : -1));
  }
}
